import { Link } from 'react-router-dom'
import { cn } from '@/lib/utils'

interface NavLink {
  label: string
  to: string
}

const accountLinks: NavLink[] = [
  { label: 'Dashboard', to: '/account/dashboard' },
  { label: 'Orders and Returns', to: '/account/orders' },
  { label: 'Credits and Refunds', to: '#' },
  { label: 'Details and Security', to: '/account/details' },
  { label: 'Address Book', to: '/account/addresses' },
  { label: 'Communication Preferences', to: '/account/preferences' },
  { label: 'Refer a Friend', to: '#' },
]

export interface AccountSidebarProps {
  activePath?: string
  className?: string
}

export function AccountSidebar({ activePath, className }: AccountSidebarProps) {
  const linkClass = (path: string) =>
    cn(
      'block py-2 text-sm uppercase tracking-[0.1em] text-carbon/60 transition-colors hover:text-wd-orange',
      activePath === path && 'font-semibold text-carbon'
    )

  return (
    <aside className={cn('border-r border-ink/10 pr-6', className)}>
      <nav className="space-y-8">
        <div>
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.14em] text-carbon">
            Loyalty Program
          </p>
          <Link
            to="/account/loyalty"
            className={linkClass('/account/loyalty')}
          >
            Access Loyalty
          </Link>
        </div>

        <div>
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.14em] text-carbon">
            My Account
          </p>
          <ul className="space-y-1">
            {accountLinks.map((link) => (
              <li key={link.label}>
                <Link to={link.to} className={linkClass(link.to)}>
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </nav>
    </aside>
  )
}
